import type { Components, Theme } from '@mui/material/styles';

export const accordionTheme: Components<Theme>['MuiAccordion'] = {
  defaultProps: {
    disableGutters: true,
    slotProps: {
      heading: {
        component: 'div'
      }
    }
  }
};

export const accordionSummaryTheme: Components<Theme>['MuiAccordionSummary'] = {
  defaultProps: {
    // MUI v6 renders the summary root as a native <button> (v5 used a
    // <div role="button">). Several summaries host interactive buttons
    // (e.g. facesheet print/edit), which produces invalid nested-button
    // HTML. Restore the v5 element to keep the markup valid.
    slotProps: {
      root: {
        component: 'div'
      }
    }
  },
  styleOverrides: {
    root: {
      fontFamily: 'Roboto'
    },
    content: {
      fontSize: '16px'
    }
  }
};
